import { createContext, useContext } from "react";
import type { Reel } from "../lib/flyerViewer";
import type { SheetKind } from "../lib/sheets";
import type { TodayDto } from "../lib/types";

export type TodayInfo = TodayDto & { first_year: number | null };

export interface AppCtx {
  /** Open a sheet over the current page (it lives in the URL). */
  open: (kind: SheetKind, value: string | number) => void;
  close: () => void;
  /** Show a flyer full size over everything, stepping through its reel. */
  zoom: (reel: Reel) => void;
  /** Bumped after any write; pages and sheets reload on it. */
  version: number;
  /** Something changed: reload everything, optionally say what. */
  changed: (message?: string) => void;
  toast: (message: string) => void;
  /** The server's local day, else the browser's. */
  today: string;
  todayInfo: TodayInfo | null;
  firstYear: number;
  email: string | null;
  signOut: () => void;
}

/** Kept apart from AppProvider so that file exports only a component (fast refresh). */
export const AppCtxContext = createContext<AppCtx | null>(null);

export function useApp(): AppCtx {
  const c = useContext(AppCtxContext);
  if (!c) throw new Error("useApp outside AppProvider");
  return c;
}
